'use client';

import { Button } from '@savvy-kit/components/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@savvy-kit/components/tooltip';
import { Ban } from 'lucide-react';

type TaxBulkActionInterfaceProps = {
  readonly selectedCount: number;
  readonly selectedCountOnPage: number;
  readonly pageRowCount: number;
  readonly eligibleCount: number;
  readonly onMarkNotInterested: () => void;
  readonly onCancel: () => void;
};

export function TaxBulkActionInterface({
  selectedCount,
  selectedCountOnPage,
  pageRowCount,
  eligibleCount,
  onMarkNotInterested,
  onCancel,
}: TaxBulkActionInterfaceProps) {
  if (selectedCount <= 0) return null;

  const isDisabled = eligibleCount === 0;

  const markNotInterestedButton = (
    <Button
      variant="ghost"
      size="default"
      className="text-destructive flex h-10 py-2 px-4 justify-center items-center gap-2 rounded-none"
      onClick={onMarkNotInterested}
      disabled={isDisabled}
    >
      <Ban className="size-4 rotate-180" />
      Mark not interested
    </Button>
  );

  return (
    <div className="fixed left-1/2 -translate-x-1/2 bottom-12 z-50 bg-white border border-slate-200 shadow-md rounded-full flex items-center">
      <div className="text-secondary px-3 py-2.5 text-sm min-w-36 text-center">
        <b className="text-dark">{selectedCountOnPage}</b> of <b className="text-dark">{pageRowCount}</b> on this page
      </div>
      <div className="border-l border-slate-200">
        {isDisabled ? (
          <Tooltip>
            <TooltipTrigger
              render={
                <span tabIndex={0} className="flex">
                  {markNotInterestedButton}
                </span>
              }
            />
            <TooltipContent side="top">
              Mark not interested is unavailable because all selected clients already have a tax enrollment.
            </TooltipContent>
          </Tooltip>
        ) : (
          markNotInterestedButton
        )}
      </div>
      <Button
        variant="ghost"
        size="default"
        className="flex h-10 py-2 px-4 justify-center items-center gap-2 rounded-r-full"
        onClick={onCancel}
      >
        Cancel
      </Button>
    </div>
  );
}
